import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import { subscribeToast } from "utils/toast";

function SlideDown(props) {
  return <Slide {...props} direction="down" />;
}

export default function ToastProvider() {
  const [open, setOpen] = React.useState(false);
  const [queue, setQueue] = React.useState([]);
  const [toast, setToast] = React.useState({
    variant: "info",
    message: "",
    anchor: { vertical: "top", horizontal: "right" },
    duration: 3000,
  });

  // listen for notify() calls
  React.useEffect(() => {
    const unsub = subscribeToast(({ variant = "info", message = "", position, duration = 3000 }) => {
      const anchor =
        position === "center"
          ? { vertical: "top", horizontal: "center" }
          : position === "bottom-right"
          ? { vertical: "bottom", horizontal: "right" }
          : { vertical: "top", horizontal: "right" }; // default

      setQueue((q) => [...q, { variant, message, anchor, duration }]);
    });
    return unsub;
  }, []);

  // dequeue
  React.useEffect(() => {
    if (!open && queue.length > 0) {
      const next = queue[0];
      setToast(next);
      setQueue((q) => q.slice(1));
      setOpen(true);
    }
  }, [queue, open]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={toast.duration}
      TransitionComponent={SlideDown}
      anchorOrigin={toast.anchor}
    >
      <Alert onClose={handleClose} severity={toast.variant} variant="filled" elevation={6}>
        {toast.message}
      </Alert>
    </Snackbar>
  );
}
